import { render, staticRenderFns } from "./PaddingTopIcon.vue?vue&type=template&id=7b801c7e&"
import script from "./PaddingTopIcon.vue?vue&type=script&lang=js&"
export * from "./PaddingTopIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports